var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.612 1.666c2.823 0 4.72 1.982 4.72 4.93v6.807c0 2.949-1.897 4.93-4.721 4.93H6.388c-2.824 0-4.722-1.981-4.722-4.93V6.597c0-2.95 1.898-4.931 4.722-4.931h7.224zM7.367 7.832a2.17 2.17 0 0 0-2.168 2.167 2.17 2.17 0 0 0 2.168 2.169c.977 0 1.795-.654 2.065-1.544h1.76v.919a.625.625 0 0 0 1.25 0v-.919h1.108v.919a.625.625 0 0 0 1.25 0V9.999a.625.625 0 0 0-.625-.625H9.432a2.163 2.163 0 0 0-2.065-1.542zm0 1.25a.92.92 0 0 1 .918.918.92.92 0 0 1-1.836 0 .92.92 0 0 1 .918-.918z",
    fill: "#4CA1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.6b7822ed70cc28f65a2116bb68a26f42.svg";
export { ForwardRef as ReactComponent };